import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import PropTypes from "prop-types";
import InputNum from "../InputNum/InputNum";
import { tree } from "../../../../../../../../utils/operations";
import { updateFromTotal, updateFromFormField, clearFormData } from "../../../../actions";
import genFieldNomenclature from "../../../../../../../../utils/genFieldNomenclature";
import formatter from "../../../../../../../../utils/formatter";
import UpArrow from "../../../../../../../../assets/icons/caret-up.png";
import DownArrow from "../../../../../../../../assets/icons/caret-down.png";
import { recordError } from "../../../../../../../../utils/commonUtil";
import { CommonTable } from '../../../../../../../../CommonComponents/commonStyles';
import { TotalSpan, TotalPercentDiv, HeaderStyle, HeaderStyle2, Triangle, InvestmentOption, FooterWrapper, TotalFooter, SpaceWrapper } from './styles';
import { Underlinelink } from "../../../ContributionType/styles";
import { RecommendAnExchangeAPIs } from '../../../../../../../../services/drupalServices';
import FundModal from "../../../../../../../Investments/Pages/RecommendAnExchangeNew/components/exchangeTo/FundModal";
import { investmentTableState } from '../../../../selectors';
import { replaceSelect } from "../../../../../../../../utils/replacer";

let rowFieldCount = -1;
let fundData = [];
let underlyingFundData = [];
let isPoolModal = false;

export class InvestmentTable extends Component {
  constructor(props) {
    super(props);
    this.renderAvailableBalance = this.renderAvailableBalance.bind(this);
    this.renderInputBox = this.renderInputBox.bind(this);
    this.clearData = this.clearData.bind(this);
    this.showPoolDetails = this.showPoolDetails.bind(this);
    this.closePoolInfo = this.closePoolInfo.bind(this);
    this.renderInvestmentOption = this.renderInvestmentOption.bind(this);
  }

  renderAvailableBalance(text) {
    return <SpaceWrapper>{
      (text.availableBalance ? 
        formatter({
          value: text.availableBalance,
          fieldSuffix: 'Dollars',
        })
      :
       <div>&mdash;</div>
      )
    }</SpaceWrapper>
  }
  
  renderAccountAllocation(text) {
    return formatter({
      value: text.percentage,
      fieldSuffix: 'Percentage',
    })
  }

  renderInputBox(text, record, index) {
    rowFieldCount += 1;
    let { availableBalance } = record;

    const fieldSuffixArr = ['Percentage'];
    const nomenclatureObj = genFieldNomenclature({
      fieldSuffixArr,
      fieldName: text.investmentOption,
      rowFieldCount,
    });

    const stuff = tree(
      'Percentage'
    );

    const obj = {
      children: <InputNum
        updateFormFields={updateFromFormField}
        updateTotal={updateFromTotal}
        fieldInfoObj={{
          ...nomenclatureObj,
          stuff,
        }}
        fieldRecord={{
          percentage: availableBalance,
        }}
        investmentOption={this.props.investmentOption}
      />,
    };

    return obj;
  }

  renderPricePerUnit(text) {
    return <SpaceWrapper>{
    (text.currentNav ? 
     <span> {formatter({
      value: text.currentNav,
      fieldSuffix: 'Dollars',
    })} <Triangle alt={(text.rise === false) ? "fall" : "rise"} src={(text.rise === false) ? DownArrow : UpArrow} /> </span>
    :
     <div>&mdash;</div>
    )
    }</SpaceWrapper>
  }

  setPoolData = (responses) => {
    if(responses && responses[0].data.length && responses[1].data.length){
      fundData = responses[0].data;
      underlyingFundData = responses[1].data;
      isPoolModal = true;
      this.setState({poolPopUp: true});
    }
  }

  closePoolInfo = () => {
    underlyingFundData = [];
    fundData = [];
    isPoolModal = false;
    this.setState({poolPopUp: false})
  }

  showPoolDetails = (value) => {
    try {
      const promises = [];
      let poolName = value.replace(' Select','');
      promises.push(RecommendAnExchangeAPIs.getInvestmentFunds({ value:  poolName }));
      promises.push(RecommendAnExchangeAPIs.getInvestmentUnderlyingFunds({ value: poolName }));
      Promise.all(promises).then((responses) => {
        this.setPoolData(responses);
      });
    } catch (error) {
      recordError(error);
    }
  }

  renderInvestmentOption(text) {
    return <Underlinelink onClick={(e) => this.showPoolDetails(text.investmentOption)}>{replaceSelect(text.investmentOption)}</Underlinelink>
  }

  clearData = () => {
    this.props.clearFormData();
  }

  renderFooter() {
    return (
      (
      (this.props.investmentOption === "valueDriven") ?
      <FooterWrapper>
      <Row type="flex">
        
          <Col lg={{ span:13}} md={{ span:13}} >
            <TotalFooter>Total:</TotalFooter>
          </Col> 
         
          <Col lg={{ span:7}} md={{ span:7}} >
            <Underlinelink id={"btnClearALl"} className={this.props.totalValue > 0 ? "block bold" : "display-none bold" } data-test='under-link' onClick={this.clearData.bind(this)}>Clear All</Underlinelink>
            
         </Col>
          <Col lg={{ span:3}} md={{ span:3}} >
            <TotalSpan>{this.props.totalValue}.00%</TotalSpan>
            <TotalPercentDiv>of 100%</TotalPercentDiv>
          </Col>
       
      </Row>
      </FooterWrapper>

      : null
      )
    )
  }

  render() {
    const {
      accountData
    } = this.props;
    const columns = [
      {
        title: <HeaderStyle>Investment Options</HeaderStyle>,
        render: this.renderInvestmentOption,
        key: 'investmentOption',
        width: '28%',
      },
      {
        title: <HeaderStyle>Available Balance <HeaderStyle2>as of {this.props.lastBusinessDate}</HeaderStyle2> </HeaderStyle>,
        render: this.renderAvailableBalance,
        key: 'availableBalance',
        width: '28%',
      },
      {
        title: <HeaderStyle>Price per unit <HeaderStyle2>as of {this.props.lastBusinessDate}</HeaderStyle2></HeaderStyle>,
        render: this.renderPricePerUnit,
        key: 'currentNav',
        width: '27%',
      },
      {
        title: <HeaderStyle>Percentage</HeaderStyle>,
        render: this.renderInputBox,
        key: 'percentShare',
        width: '15%',
      }
    ];

    return (
      <FooterWrapper>
      <CommonTable className="w100"
        data-test='common-table'
        pagination={false}
        footer={currPageData => this.renderFooter(currPageData)}
        columns={columns}
        dataSource={accountData[this.props.investmentOption]}
      />
      <FundModal
                data-test='fund-modal'
                visible={isPoolModal}
                poolUf={underlyingFundData}
                poolData={fundData}
                cancelOptionModal={() => this.closePoolInfo()}
            />
      </FooterWrapper>
    );
  }
}

InvestmentTable.propTypes = {
  exchangeType: PropTypes.string,
  accountData: PropTypes.object,
  totalValue: PropTypes.string,
  recordedValue: PropTypes.string,
  dummyData: PropTypes.bool,
  lastBusinessDate: PropTypes.string,
  updateFromTotal: PropTypes.func,
  clearFormData: PropTypes.func,
}

const mapStateToProps = state => ({
  ...investmentTableState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  updateFromTotal: reset => dispatch(updateFromTotal(reset)),
  clearFormData: () => dispatch(clearFormData())
});

export default connect(mapStateToProps,mapDispatchToProps)(InvestmentTable);
